import routes from 'common/routes';
import { AntCol } from 'components/ant/AntCol';
import { AntRow } from 'components/ant/AntRow';
import { HeaderLogo } from 'components/Header/HeaderLogo';
import { LanguageChanger } from 'components/LanguageChanger';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import styles from './PublicHeader.module.less';

const DTI = 'Header';

export const PublicHeader: FC = () => {
  // The header outlives the page under it, so it follows the router rather than reading the URL once.
  const { pathname } = useLocation();
  const isSignUpPage = pathname.includes(routes.profileSignUp);
  const { t } = useTranslation();

  return (
    <AntRow data-testid={DTI} className={styles.container}>
      <AntCol xl={12} sm={12} xs={14} className={styles.logoCnt}>
        <HeaderLogo data-testid={`${DTI}__Logo`} />
      </AntCol>
      <AntCol xl={12} sm={12} xs={10} className={styles.menuCnt}>
        <LanguageChanger />
        <div className={styles.signBtns}>
          {isSignUpPage ? (
            <Trans t={t} i18nKey={'buttons.signInLink'}>
              <span>Already a partner?</span>
              <Link data-testid={`${DTI}__SignIn`} to={routes.profileSignIn}>
                Sign in
              </Link>
            </Trans>
          ) : (
            <Trans t={t} i18nKey={'buttons.signUpLink'}>
              <span>Not a partner? </span>
              <Link data-testid={`${DTI}__SignUp`} to={routes.profileSignUp}>
                Sign up now
              </Link>
            </Trans>
          )}
        </div>
      </AntCol>
    </AntRow>
  );
};
